/**
 * Change Item Status Dialog component
 *
 * @author Monika Gole <monika.gole@ncircletech.com>
 * @copyright (c) 2024 Build Centrix
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { WdModelStatusService } from '../../../services/modelViewer/wd-model-status.service';
import { FormBuilder, Validators } from '@angular/forms';
import { IStatusMap } from '../../../interfaces/spools/spool-interfaces';

@Component({
  selector: 'app-change-item-status-dialog',
  templateUrl: './change-item-status-dialog.component.html',
  styleUrls: ['./change-item-status-dialog.component.scss'],
})

/**
 * ChangeItemStatusDialogComponent class
 */
export class ChangeItemStatusDialogComponent implements OnInit {
  /**
   * Selected status
   */
  selectedStatus: IStatusMap;

  /**
   * Item status model
   */
  itemStatusModel: IStatusMap;

  /**
   * Statuses data
   */
  statusesData: BehaviorSubject<IStatusMap[]> = new BehaviorSubject([]);

  /**
   * Constructor
   */
  constructor(
    public dialog: MatDialog,
    public wdModelStatusService: WdModelStatusService,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private formBuilder: FormBuilder,
  ) {}

  /**
   * Form
   */
  updateStatusForm = this.formBuilder.group({
    status: ['', Validators.compose([Validators.required])],
  });

  /**
   * On init
   */
  ngOnInit(): void {
    const transformedData = this.data.statusesMappingsData.map((item: any) => ({
      ...item,
      displayLabel: item.input.label,
    }));

    this.statusesData.next(transformedData);
  }

  /**
   * On cancel
   */
  onCancel(): void {
    // Close modal
    this.dialog.closeAll();
  }

  /**
   * On item status changed
   */
  onItemStatusChanged(event: any) {
    this.selectedStatus = event;
  }

  /**
   * On update
   */
  async onUpdate(): Promise<void> {
    if (this.selectedStatus !== undefined) {
      await this.wdModelStatusService.updateItemStatusInModel(
        this.data.selectedModelId,
        {
          dbIds: this.data.dbIds,
          viewer: this.data.viewer,
          statusesMappingsData: this.data.statusesMappingsData,
          statusChangeResult: this.selectedStatus,
        },
      );
    }

    // Close modal
    this.dialog.closeAll();
  }
}
